import { PageLoader } from '@customerio/pluma-components/react';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { RumPageRendered } from '@/services/rum/use-page-rendered';

// The in-app message builder's iframe editor (Journeys). Lazy, so the editor (and the page module, which marks the page
// as embedded when it loads) stays out of every other chunk.
const InAppEmbedPage = lazy(() => import('@/pages/workspaces/design-studio/embed/cio/in-app/embed-route.page'));

function InAppEmbedRoute() {
  return (
    <Suspense fallback={<PageLoader />}>
      <RumPageRendered>
        <InAppEmbedPage />
      </RumPageRendered>
    </Suspense>
  );
}

export const Route = createFileRoute('/design-studio-embed/cio/in-app')({
  component: InAppEmbedRoute,
});
